module.exports = __webpack_public_path__ + "img/ds-vanilla@2x.fd8e5f6b.jpg";